import { useDucatClient } from '@/context/DucatClientCtx';

import { QuantaHeaders, buildQuantaHeaders, signQuantaAuth } from './auth';
import { useQuantaRegister } from './useQuantaRegister';

/**
 * To request a signature from wallet and set auth headers on DucatContext.
 */
export function useQuantaAuth() {
  const { setQuantaHeaders, walletAddress, pubkey, client } = useDucatClient();
  const { mutateAsync: register, isPending: isRegisterPending, error: registerError, reset: resetRegisterError } = useQuantaRegister();

  async function signQuanta() {
    if (!pubkey || !walletAddress) {
      throw Error('Wallet not ready');
    }

    const authParams = await signQuantaAuth({
      address: walletAddress,
      pubkey,
      client,
    });

    const headers = buildQuantaHeaders(authParams);

    setQuantaHeaders(headers);

    return headers;
  }

  async function registerUser(headers: QuantaHeaders, referralCode: string) {
    if (headers && walletAddress && pubkey) {
      try {
        const userData = await register({ headers, referralCode });

        return userData;
      } catch (e: any) {
        if (e.status === 409 && e.response.data?.error === 'User with this wallet or public key already exists') {
          // This is OK.
          console.log(`User already registered and can login.`);
        } else {
          throw e;
        }
      }
    } else {
      throw Error('Wallet is not ready');
    }
  }

  return { signQuanta, registerUser, isRegisterPending, registerError, resetRegisterError };
}
